import { render, staticRenderFns } from "./Follow.vue?vue&type=template&id=2d5243ae&scoped=true&"
import script from "./Follow.vue?vue&type=script&lang=ts&"
export * from "./Follow.vue?vue&type=script&lang=ts&"
import style0 from "./Follow.vue?vue&type=style&index=0&id=2d5243ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5243ae",
  null
  
)

export default component.exports